"use client";

import React, { PropsWithChildren } from "react";
import { ChildThemeProvider, getThemeFromDealerName } from "./ThemeProvider";

export const DepartmentThemeWrapper = ({
  departmentSlug,
  children,
}: PropsWithChildren<{
  departmentSlug: string;
}>) => {
  const theme = () => getThemeFromDealerName(departmentSlug);

  return <ChildThemeProvider theme={theme()}>{children}</ChildThemeProvider>;
};
